/** Shared utilities for the User Level Data tab (session + seat history). */

/**
 * Format a duration in seconds to a plain integer number of minutes.
 *
 * Rounds to the nearest minute with a minimum of 1.
 * - 0–29s  → 1
 * - 30–89s → 1
 * - 90s    → 2
 * - 300s   → 5
 * - 3720s  → 62
 */
export const formatDurationMinutes = (totalSeconds: number): string => {
  return String(Math.max(1, Math.round(totalSeconds / 60)));
};

export const resolveUserDisplayName = (
  userId: string,
  userDisplayNames?: Map<string, string>,
): string =>
  userDisplayNames === undefined
    ? userId
    : (userDisplayNames.get(userId) ?? `[Deleted] ${userId.slice(0, 8)}`);

/**
 * Trigger a CSV file download from in-memory content.
 *
 * Prepends a UTF-8 BOM so Excel opens the file with correct encoding.
 */
export function downloadCsvFile(csvContent: string, filename: string): void {
  const blob = new Blob([`\uFEFF${csvContent}`], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
